/*
 *   File : sip-detail.js
 *   Author URI : https://evoqins.com
 *   Description :  SIP transaction details of a selected transition
 *   Integrations : null
 *   Version : v1.1
 */

import { Fragment } from "react"
import { Icon } from "../../../Components/Icon"


import style from "../../../Styles/Components/sip-detail.module.scss"

const INSTALLMENTS = [{
    installment_number: "5th",
    date: "3 Oct 2023",
    status: 1
},
{
    installment_number: "4th",
    date: "3 Oct 2023",
    status: 2
},
{
    installment_number: "3rd",
    date: "3 Oct 2023",
    status: 3
},
{
    installment_number: "2nd",
    date: "3 Oct 2023",
    status: 3
},
{
    installment_number: "1st",
    date: "3 Oct 2023",
    status: 3
}]

const SIPDetail = () => {

    // listener for opening cancel modal





    const Heading = (props) => {
        return (
            <div className={`d-flex ${props.className}`}>
                <p className="color-gray e-poppins-medium e-font-16 line-height-16px mb-0">{props.heading}&nbsp;</p>
                <p className="color-outer-space e-poppins-medium e-font-16 line-height-16px mb-0">{props.answer}</p>
            </div>

        )
    }

    const PaymentAndOtherActivities = (props) => {
        return (
            <div className="mt-3">
                <p className="color-gray e-poppins-medium e-font-16 line-height-16px margin-10px-bottom e-payment-other-activities">{props.heading}</p>
                <p className="color-black e-poppins-semi-bold e-font-18 line-height-16px mb-0">{props.answer}</p>
            </div>
        )
    }

    return (
        <Fragment>
            <div className="border-radius-24px border-all border-bright-gray p-4">
                <div className="border-bottom-1px border-bright-gray pb-3 d-flex justify-content-between align-items-center flex-wrap">
                    <div className="d-flex align-items-center gap-12px">
                        <div className="border-all border-bright-gray border-radius-8px p-2">
                            <img draggable={false} src={require("../../../Assets/Images/Dashboard/escorts.svg").default}
                                alt="Quant Small Cap Fund Direct Plan Growth"
                                width={36}
                                height={36} />
                        </div>
                        <p className="color-black e-poppins-medium e-font-16 line-height-16px mb-0">Quant Small Cap Fund Direct Plan Growth</p>
                    </div>
                    <div>
                        <p className="color-outer-space e-poppins-semi-bold e-font-20 line-height-20px mb-0 mt-lg-0 mt-md-0 mt-sm-0 mt-3"><span className="e-inter-semi-bold">₹</span>100</p>
                        <p className="color-gray e-poppins-regular e-font-12 line-height-18px mb-0">SIP amount</p>
                    </div>
                </div>
                <div className="mt-3 d-flex flex-wrap justify-content-between align-items-center">
                    <Heading heading="Last installment:"
                        answer="3th Sep 2023" />
                    <div className="d-flex align-items-center border-all border-primary-color border-radius-30px bg-pale-steel-blue px-3 padding-12px-tb mt-lg-0 mt-md-0 mt-sm-0 mt-3">
                        <p className="color-gray e-poppins-medium e-font-16 line-height-16px mb-0">Next installment &nbsp;</p>
                        <p className="color-primary-color e-poppins-semi-bold e-font-16 mb-0">3 Oct 2023</p>
                    </div>
                </div>
                <div className="d-flex justify-content-between mt-2 flex-wrap">
                    <Heading heading="SIP created on:"
                        answer="4th Aug 2023"
                        className="mt-lg-0 mt-md-0 mt-sm-0 mt-3" />
                    <Heading heading="First purchase:"
                        answer="Yes"
                        className="mt-lg-0 mt-md-0 mt-sm-0 mt-4" />
                </div>
                <div className="border-radius-16px bg-light-grayish-white p-3 my-4">
                    <div className="d-flex justify-content-between flex-wrap">
                        <Heading heading="SIP mandate:"
                            answer="MTMF00123" />
                        <Heading heading="Start date:"
                            answer="1 Oct 2023"
                            className="mt-lg-0 mt-md-0 mt-sm-0 mt-3" />
                    </div>
                    <div className="d-flex justify-content-between mt-3 flex-wrap">
                        <Heading heading="Bank:"
                            answer="Federal Bank (XXXXX2406)" />
                        <Heading heading="End date:"
                            answer="1 Oct 2026"
                            className="mt-lg-0 mt-md-0 mt-sm-0 mt-3" />
                    </div>

                </div>

            </div>

            <p className="color-jett-black e-poppins-medium e-font-16 my-3">Payments and other activities.</p>
            <div className="border-all border-bright-gray pb-3 px-4 d-flex flex-wrap e-payment-activities-wrapper border-radius-16px">
                <PaymentAndOtherActivities heading="Total no. of installments"
                    answer="10" />
                <PaymentAndOtherActivities heading="Missed installments"
                    answer="2" />
                <PaymentAndOtherActivities heading="Rejected installments"
                    answer="0" />
                <PaymentAndOtherActivities heading="Remaining installments"
                    answer="26" />
            </div>
            <div className="border-radius-24px border-all border-bright-gray p-4 mt-3">
                {
                    INSTALLMENTS.map((item, key) =>
                        <div key={key}
                            className={`d-flex gap-8px  cursor-pointer ${INSTALLMENTS.length - 1 !== key && "border-bottom-1px border-bright-gray mb-3 pb-3"}`}>
                            <Icon icon={item.status === 1 ? "upcoming" : item.status === 2 ? "cancelled" : "check-green"}
                                size={24} />
                            <div className="w-100">
                                <div className="d-flex justify-content-between align-items-center ">
                                    <div>
                                        <div className="d-flex gap-16px align-items-center mb-2">
                                            <p className="color-outer-space e-poppins-medium e-font-16 line-height-16px mb-0">{item.installment_number} installment: {item.status === 1 ? "Not paid yet" : item.status === 2 ? "Failed" : "Paid"}</p>
                                            {
                                                item.status !== 1 &&
                                                <p className={`position-relative e-font-14 e-poppins-regular mb-0 ${style.e_sip}`}>SIP</p>
                                            }
                                        </div>
                                        <p className="color-outer-space e-poppins-regular e-font-14 line-height-16px mb-0">{item.date}</p>
                                    </div>
                                    {
                                        item.status === 1 ?
                                            <p className="color-yellow-orange e-poppins-medium e-font-14 line-height-18px mb-0">Upcoming</p>
                                            :
                                            item.status === 2 ?
                                                <p className="color-lust e-poppins-medium e-font-14 line-height-18px mb-0">Failed</p>
                                                :
                                                <p className="color-sea-green e-poppins-medium e-font-14 line-height-18px mb-0">Success</p>
                                    }
                                </div>
                                {
                                    item.status === 2 &&
                                    <div className="row mt-2">
                                        <div className="col-lg-10 col-md-10">
                                            <div className="border-radius-8px bg-mint-cream py-3 px-2 d-flex align-items-center">
                                                <Icon icon="info"
                                                    size={24} />
                                                <p className="color-jett-black e-poppins-regular e-font-14 line-height-22px mb-0">Your SIP order failed due to insufficient bank balance.</p>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    )
                }

            </div>



        </Fragment>
    )
}

export default SIPDetail